import React, { useEffect, useState } from "react";
import PropTypes from "kf-proptypes/widgets";

import { ResetDialog } from "@widgets/inputs/index.jsx";
import {
  ICON_SIZE,
  KF_ICONS,
  ICON_STROKE,
  KfIcon
} from "@widgets/common/components/primitives/kf_icon/index.jsx";

import styles from "./styles.css";

export const TEXT_STYLE_VALUES = {
  ITALIC: "italic",
  UNDERLINE: "underline",
  LINE_THROUGH: "line-through"
};

const TEXT_STYLE_CONSTANTS = {
  FONT_STYLE: "fontStyle",
  TEXT_DECORATION_LINE: "textDecorationLine"
};

const DEFAULT_STATE = {
  [TEXT_STYLE_CONSTANTS.FONT_STYLE]: "",
  [TEXT_STYLE_CONSTANTS.TEXT_DECORATION_LINE]: ""
};

export function TextStyleProperties({
  label,
  value = {},
  onChange = () => {},
  showReset = false,
  modified = false,
  onReset = () => {}
}) {
  const [styleState, setStyleState] = useState(DEFAULT_STATE);

  function onStyleToggle(property, value) {
    const newState = Object.assign({}, styleState);
    let oldValue = newState[property];

    if (oldValue.includes(value)) {
      newState[property] = oldValue.replace(value, "");
    } else if (
      oldValue.length === 0 ||
      oldValue === "none" ||
      oldValue === "normal"
    ) {
      newState[property] = value;
    } else {
      newState[property] += " " + value;
    }
    newState[property] = newState[property].trim() || "normal";

    setStyleState(newState);
    onChange(newState);
  }

  useEffect(
    function onValueChange() {
      setStyleState({ ...DEFAULT_STATE, ...value });
    },
    [value]
  );

  return (
    <div className={`${styles.inlinePropertyRow}`}>
      <div className={styles.title}>
        <span className={`tiny ${styles.label}`}>{label}</span>
        <div className={styles.resetIcon}>
          {showReset && modified && <ResetDialog onReset={onReset} />}
        </div>
      </div>
      <section className={styles.multitab}>
        <div
          onClick={() =>
            onStyleToggle(
              TEXT_STYLE_CONSTANTS.TEXT_DECORATION_LINE,
              TEXT_STYLE_VALUES.UNDERLINE
            )
          }
          className={`${styles.tab} ${
            styleState[TEXT_STYLE_CONSTANTS.TEXT_DECORATION_LINE]?.includes?.(
              TEXT_STYLE_VALUES.UNDERLINE
            )
              ? styles.selected
              : ""
          }`}
        >
          <KfIcon
            icon={KF_ICONS.UNDERLINE}
            size={ICON_SIZE.SIZE_16}
            stroke={ICON_STROKE.THIN}
          />
        </div>
        <div
          onClick={() =>
            onStyleToggle(
              TEXT_STYLE_CONSTANTS.TEXT_DECORATION_LINE,
              TEXT_STYLE_VALUES.LINE_THROUGH
            )
          }
          className={`${styles.tab} ${
            styleState[TEXT_STYLE_CONSTANTS.TEXT_DECORATION_LINE]?.includes?.(
              TEXT_STYLE_VALUES.LINE_THROUGH
            )
              ? styles.selected
              : ""
          }`}
        >
          <KfIcon
            icon={KF_ICONS.TEXT_STRIKETHROUGH}
            size={ICON_SIZE.SIZE_16}
            stroke={ICON_STROKE.THIN}
          />
        </div>
        <div
          onClick={() =>
            onStyleToggle(
              TEXT_STYLE_CONSTANTS.FONT_STYLE,
              TEXT_STYLE_VALUES.ITALIC
            )
          }
          className={`${styles.tab} ${
            styleState[TEXT_STYLE_CONSTANTS.FONT_STYLE]?.includes?.(
              TEXT_STYLE_VALUES.ITALIC
            )
              ? styles.selected
              : ""
          }`}
        >
          <KfIcon
            icon={KF_ICONS.ITALIC}
            size={ICON_SIZE.SIZE_16}
            stroke={ICON_STROKE.THIN}
          />
        </div>
      </section>
    </div>
  );
}

TextStyleProperties.propTypes = {
  showReset: PropTypes.bool,
  label: PropTypes.string.isRequired,
  value: PropTypes.objectOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  modified: PropTypes.bool
};
